import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export async function registerServiceWorker() {
  if (!pushSupported()) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch {
    return null;
  }
}

export async function subscribeToPush(dancerId) {
  if (!pushSupported() || !dancerId) return { ok: false, reason: "unsupported" };

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { ok: false, reason: "denied" };

  const reg = await registerServiceWorker();
  if (!reg) return { ok: false, reason: "no-sw" };

  const keyRes = await api.get("/notifications/vapid-public-key");
  const publicKey = keyRes.data?.public_key;
  if (!publicKey) return { ok: false, reason: "no-vapid" };

  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  const json = subscription.toJSON();
  await api.post(`/dancers/${dancerId}/push-subscription`, {
    endpoint: json.endpoint,
    p256dh: json.keys?.p256dh,
    auth: json.keys?.auth,
  });

  return { ok: true };
}

export async function unsubscribeFromPush(dancerId) {
  if (!pushSupported() || !dancerId) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager?.getSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  try {
    await api.delete(`/dancers/${dancerId}/push-subscription`, { data: { endpoint } });
  } catch {
    // ignore
  }
}

export async function getPushSubscriptionState() {
  if (!pushSupported()) return { supported: false, subscribed: false };
  let reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) reg = await registerServiceWorker();
  const sub = await reg?.pushManager?.getSubscription();
  return { supported: true, subscribed: Boolean(sub) };
}

export function getNotificationPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission;
}

export async function shouldOfferPush() {
  if (!pushSupported()) return false;
  if (Notification.permission === "denied") return false;
  const state = await getPushSubscriptionState();
  return !state.subscribed;
}
